import {
  ModalContent,
  ModalRoot,
  ModalTrigger,
} from '@synoptic/ui-kit/modal/modal.js';
import { FC, ReactNode, useState } from 'react';
import { NewPostForm } from '../new-post-modal/form.tsx';
import { useAddStreamPost } from './use-add-stream-post.ts';

export type NewStreamPostModalProps = {
  trigger: ReactNode;
  streamId: string;
  label?: string;
};

export const NewStreamPostModal: FC<NewStreamPostModalProps> = ({
  trigger,
  streamId,
}) => {
  const [open, onOpenChange] = useState(false);
  const [addStreamPost] = useAddStreamPost();

  return (
    <ModalRoot open={open} onOpenChange={onOpenChange}>
      <ModalTrigger asChild>{trigger}</ModalTrigger>
      <ModalContent>
        <NewPostForm
          onSubmit={async ({ text, media }) => {
            await addStreamPost({
              streamId,
              text,
              media,
            });
            onOpenChange(false);
          }}
        />
      </ModalContent>
    </ModalRoot>
  );
};
